import { TRAVELER_FORM_SECTION_NAME } from './constants';
const getTravelerFormSectionName = (id, subSection) => `${TRAVELER_FORM_SECTION_NAME}-${id}${subSection ? `.${subSection}-${id}` : ''}`;
export default getTravelerFormSectionName;